import { createKsStore, ObjetKForm, type KsStoreHook } from '@siclop/kstone-vue'
import { LeaveBalance } from '../models/LeaveBalance'
import { LeaveBalanceFilter } from '../filters/LeaveBalanceFilter'
import { LeaveBalanceService } from '../services/LeaveBalanceService'

class LeaveBalanceForm extends ObjetKForm {
  constructor(data?: Partial<LeaveBalanceForm>) { super(data) }
}

export const useLeaveBalanceStore: KsStoreHook<LeaveBalance, LeaveBalanceForm, LeaveBalanceFilter> = createKsStore({
  id: 'leaveBalances',
  modelClass: LeaveBalance,
  formClass: LeaveBalanceForm,
  filterClass: LeaveBalanceFilter,
  service: LeaveBalanceService,
  labelField: (item) => `${item.leaveTypeName || 'Solde'} ${item.periodStartYear}`,
  signalREventName: 'LeaveBalanceModel'
})
